// Utils & misc
import cn from '../../../utils/cn';

// Style
import style from './FloatingMenu.module.css';

/**
 * FloatingMenu component - Fixed positioned menu at bottom center of screen
 * @param {object} params
 * @param {React.ReactNode} params.children - Content of the floating menu
 * @param {string} [params.className] - Additional CSS classes
 * @returns {JSX.Element} FloatingMenu component
 */
function FloatingMenu({
  children,
  className,
}) {
  return (
    <div className={cn([style['floating-menu'], ...(className ? [className] : [])])}>
      {children}
    </div>
  );
}

/**
 * FloatingMenuGroups component - Container for multiple groups with separators
 * @param {object} params
 * @param {React.ReactNode} params.children - FloatingMenuGroup components
 * @param {string} [params.className] - Additional CSS classes
 * @returns {JSX.Element} FloatingMenuGroups component
 */
function FloatingMenuGroups({
  children,
  className,
}) {
  return (
    <div className={cn([style['floating-menu-groups'], ...(className ? [className] : [])])}>
      {children}
    </div>
  );
}

/**
 * FloatingMenuGroup component - Groups items within the floating menu
 * @param {object} params
 * @param {React.ReactNode} params.children - Content of the group
 * @param {string} [params.className] - Additional CSS classes
 * @returns {JSX.Element} FloatingMenuGroup component
 */
function FloatingMenuGroup({
  children,
  className,
}) {
  return (
    <div className={cn([style['floating-menu-group'], ...(className ? [className] : [])])}>
      {children}
    </div>
  );
}

export default FloatingMenu;
export { FloatingMenuGroups, FloatingMenuGroup };
